<template>
	<div id="accounts" class="page">
		<datatable
			model="accounts"
			modal="Account"
			route="account"
		></datatable>
		<router-view />
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datatable from '../components/Elements/Datatable'

export default {
  name: 'Accounts',
  data () {
    return {
      //
    }
  },
  components: {
    Datatable
  },
  computed: {
    //
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ])
  },
  created () {
    this.setPageTitle('Accounts')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts.vue